export enum Level {
    WARN, ERROR, LOG, LOG_OBJECT, WARN_OBJECT
}
